<template>
  <div v-if="errors.length" class="v-text-field__details">
    <div class="v-messages theme--light error--text" role="alert">
      <div class="v-messages__wrapper">
        <div v-for="error in errors" :key="error" class="v-messages__message">
          {{ error }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ArticleFormFieldErrors',
  props: {
    errors: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
